import { useDatoQuerySubscription } from '@src/hooks/useDatoQuerySubscription';
import { useEffect } from 'react';

import { STORY_ARTIFACTS_VIDEO_QUERY } from '../gql/media-gql';

import type { StoryArtifactsVideoUpdate } from '../types.ts/story';

export const useQueryStoryVideos = (
  ids: string[],
): {
  status: string;
  error: any;
  data: { allStories: StoryArtifactsVideoUpdate[] } | undefined;
} => {
  const { status, error, data } = useDatoQuerySubscription<
    { allStories: StoryArtifactsVideoUpdate[] },
    { ids: string[] }
  >({
    query: STORY_ARTIFACTS_VIDEO_QUERY,
    variables: { ids },
  });
  return { status, error, data };
};

const StoryArtifactsVideoSubscription = (props: {
  storyIds: string[];
  onDataReceived: (updates: StoryArtifactsVideoUpdate[]) => void;
  onError: (error: any) => void;
}) => {
  const { storyIds, onDataReceived, onError } = props;
  const { error, data } = useQueryStoryVideos(storyIds);

  useEffect(() => {
    if (error) {
      onError(error);
    } else if (data?.allStories?.length) {
      onDataReceived(data.allStories);
    }
  }, [data, error]);

  return <></>;
};

export default StoryArtifactsVideoSubscription;
